import api from "api";
import { Checklist } from "models/Checklist";
import { MediaEntity } from "models/MediaEntity";

export type GetAllIncludedImagesRequest = Checklist[];
export type GetAllIncludedImagesResponse = MediaEntity[];

type FileWithChecklist = {
  fileId: string;
  checklistId: string;
};

export const getAllIncludedImages = async (checklists: GetAllIncludedImagesRequest) => {
  const filesWithChecklist: FileWithChecklist[] = checklists.flatMap((checklist) => {
    return checklist.verification
      .filter((item) => item.type === 1 && item.excludedFromPdf === false)
      .map((item) => ({ fileId: item.id, checklistId: checklist.id }));
  });

  return Promise.all(
    filesWithChecklist.map((item) => api.bin.getMediaEntity(item.fileId, item.checklistId))
  );
};
